export default {
      id: "arrowdown2-brown-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#arrowdown2-brown",
      toString: function () {
        return this.url;
      }
    }